import { GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { getLocale, setLocale } from '@umijs/max';
import React from 'react';
import HeaderDropdown from '../HeaderDropdown';
import { useSupportedLanguages } from '@/utils/languageConfig';

export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
	const selectedLang = getLocale();
	const languages = useSupportedLanguages();

	const menuItems = languages.map((lang) => ({
		key: lang.value,
		label: (
			<>
				<span role="img" aria-label={lang.label} style={{ marginRight: 8 }}>
					{lang.flag || '🌐'}
				</span>
				{lang.label}
			</>
		),
		onClick: () => {
			setLocale(lang.value, true);
		}
	}));

	return (
		<HeaderDropdown
			menu={{
				selectedKeys: [selectedLang],
				items: menuItems
			}}
			placement="bottomRight"
		>
			<span
				style={{
					cursor: 'pointer',
					display: 'inline-flex',
					alignItems: 'center',
					fontSize: 18
				}}
			>
				<GlobalOutlined />
			</span>
		</HeaderDropdown>
	);
};

export const Question: React.FC = () => {
	return (
		<a
			href="https://www.atomic-art.com"
			target="_blank"
			rel="noreferrer"
			style={{
				display: 'inline-flex',
				padding: '4px',
				fontSize: '18px',
				color: 'inherit'
			}}
		>
			<QuestionCircleOutlined />
		</a>
	);
};
